export default {
  "cabinet": {
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])},
    "nickname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Псевдоним"])},
    "card": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер карты"])},
    "lang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Язык"])},
    "ru": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Русский"])},
    "ua": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Украинский"])},
    "gender": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пол"])},
    "male": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мужской"])},
    "female": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Женский"])},
    "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата рождения"])},
    "city": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Город"])},
    "cityChose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите город"])},
    "cityOptions": {
      "kiev": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Киев"])},
      "lvov": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Львов"])},
      "odessa": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Одесса"])}
    }
  },
  "header": {
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])},
    "poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Афиша"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Расписание"])},
    "cinemas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кинотеатры"])},
    "sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Акции"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["О кинотеатре"])},
    "news": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новости"])},
    "contacts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакты"])},
    "cabinet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мой кабинет"])},
    "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Логин"])},
    "registration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрация"])}
  },
  "footer": {
    "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобильные приложения"])},
    "poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Афиша"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Расписание"])},
    "cinemas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кинотеатры"])},
    "sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Акции"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["О кинотеатре"])},
    "news": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новости"])}
  },
  "home": {
    "now": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Смотрите сегодня"])},
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купите билет"])},
    "soon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Смотрите скоро"])},
    "news": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новости и акции"])}
  },
  "film": {
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купите билет"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Расписание сеансов в кинотеатре:"])},
    "posters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кадры и постеры"])},
    "cinema": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кинотеатр:"])}
  },
  "poster": {
    "now": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сейчас в кино"])},
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купите билет"])},
    "poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Афиша"])}
  },
  "schedule": {
    "cinemas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Все кинотеатры"])},
    "films": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Все фильмы"])},
    "halls": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Все залы"])},
    "list": {
      "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Время"])},
      "film": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фильм"])},
      "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Цена"])},
      "reserve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бронировать"])}
    },
    "not-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сеансов не найдено"])}
  },
  "order": {
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Цена в грн"])},
    "tickets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Билетов"])},
    "sum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сумма"])},
    "screen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ЭКРАН"])},
    "order-rules": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Строимость бронирования - 3 грн. за каждое место"])},
    "order-time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ЗАБРОНИРОВАННЫЕ БИЛЕТЫ НУЖНО ВЫКУПИТЬ В КАССЕ НЕ РАНЬШЕ ЧЕМ ЗА ПОЛЧАСА ДО НАЧАЛА СЕАНСА"])},
    "order-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ЗАБРОНИРОВАТЬ"])},
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["КУПИТЬ"])}
  },
  "cinemas": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Наши кинотеатры"])},
    "conditions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Условия"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Расписание сеансов"])},
    "countHalls": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кол-во залов"])},
    "now": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Смотрите сегодня"])}
  },
  "sales": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Акции и скидки"])}
  },
  "news": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новости"])}
  },
  "contacts": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакты"])}
  }
}